import moment from 'moment'
import 'moment/locale/de'
import 'moment/locale/it'
import 'moment/locale/en-gb'
import { registerLocale, setDefaultLocale } from 'react-datepicker'
import de from 'date-fns/locale/de'
import it from 'date-fns/locale/it'
import enGB from 'date-fns/locale/en-GB'

// Weekday and month names in moment and in the date picker follow the UI language.
// A new language adds its moment locale import and its date-fns locale here.
// English is British English: weeks start on Monday, dates read 04/11/2026.
const DATE_FNS_LOCALES = { de, it, en: enGB } as const

/** moment's name for a UI language where it differs (moment's plain 'en' is American) */
const MOMENT_LOCALES: Record<string, string> = { en: 'en-gb' }

for (const [code, loc] of Object.entries(DATE_FNS_LOCALES)) registerLocale(code, loc)

/** called by setCurrentTexts whenever the UI language changes */
export function applyDateLocale(lang: string): void {
    moment.locale(MOMENT_LOCALES[lang] ?? lang) // an unknown code keeps moment's current locale
    if (Object.prototype.hasOwnProperty.call(DATE_FNS_LOCALES, lang)) setDefaultLocale(lang)
}
